"use client";

import {useState} from "react";
import Link from "next/link";
import {usePathname} from "next/navigation";
import VERSION from "@/lib/version";
import SecretSwitch from "@/components/SecretSwitch";
import MenuGoomy from "@/components/menu/MenuGoomy";
import VersionTag from "@/components/menu/VersionTag";

const menuPages = [
  {
    name: "Blog",
    uri: "blog",
  },
  {
    name: "Music",
    uri: "music",
  },
  {
    name: "About Me",
    uri: "about",
  },
  {
    name: "Info",
    uri: "info",
  },
];

const Navbar = ({initialSecretMode}) => {
  const [shown, setShown] = useState(false);
  const pathname = usePathname();
  const navLinkClass = uri => {
    let klass = "navbar-item is-tab";
    if (pathname.startsWith(`/${uri}`)) {
      klass += " is-active";
    }

    return klass;
  };
  const toggleMenu = () => {
    setShown(!shown);
  };

  return (
    <nav className="navbar is-fixed-top has-shadow">
      <div className="navbar-brand">
        <Link className="navbar-item is-size-3 p-0" href="/">
          <strong className="navbar-logo">
            <tt> Serge&rsquo;s Lair</tt>
          </strong>
        </Link>
        <div className="navbar-item is-hidden-desktop p-0">
          <SecretSwitch initialSecretMode={initialSecretMode} inline={true}>
            <VersionTag branch={VERSION.branch}
                        release={VERSION.release}
                        version={VERSION.version}
            />
          </SecretSwitch>
        </div>
        <div className={`navbar-burger${shown ? " is-on" : ""}`}
             onClick={toggleMenu}
        >
          <MenuGoomy/>
        </div>
      </div>
      <div className={`navbar-menu ${shown ? "is-active" : ""}`}>
        <div className="navbar-start">
          {menuPages.map(page => (
            <Link key={page.uri}
                  className={navLinkClass(page.uri)}
                  href={`/${page.uri}`}
                  onClick={() => setShown(false)}
            >
              {page.name}
            </Link>
          ))}
        </div>
        <div className="navbar-end is-hidden-touch">
          <div className="navbar-item">
            <SecretSwitch initialSecretMode={initialSecretMode} inline={true}>
              <VersionTag branch={VERSION.branch}
                          release={VERSION.release}
                          version={VERSION.version}
              />
            </SecretSwitch>
          </div>
          <MenuGoomy/>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
